import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import * as FileSaver from 'file-saver';
import { environment } from '../../environments/environment';
// import * as _ from 'lodash';
import {PlatformLocation } from '@angular/common';

@Injectable()

export class UtilsService {
	url: any= "";
	commonMsg: any= "";
	SESSION_TTL: number = 10; // in mins;
	snackRef: any;
	constructor(private router: Router, private matSnackBar: MatSnackBar, platformLocation: PlatformLocation) {
	//console.log((platformLocation as any).location.host);
	if((platformLocation as any).location.host=="localhost:4200"){
		this.url= "http://10.4.11.30:8080/DDMF";
		//this.url= "http://localhost:8080";	
	}
	else if((platformLocation as any).location.host=="10.4.10.30"){
		this.url= "http://10.4.11.30:8080/DDMF";
	}
	else if((platformLocation as any).location.host=="10.4.10.33"){
		this.url= "http://10.4.11.51:8080/DDMF";
	}
	else if((platformLocation as any).location.host=="10.4.10.32"){
		this.url= "http://10.4.11.50:8080/DDMF";
	}
	else if((platformLocation as any).location.host=="uat-telco.ctos.com.my"){
		this.url= "//uat-telco.ctos.com.my/DDMF";
	}
	else if((platformLocation as any).location.host=="telco.ctos.com.my"){
		this.url= "//telco.ctos.com.my/DDMF";
	}
	else if((platformLocation as any).location.host=="telco.emr.com.my"){
		this.url= "//telco.emr.com.my/DDMF";
	}
	else if((platformLocation as any).location.host=="dc-arweb01-uat.ctos.com.my"){
		this.url= "http://10.4.11.51:8080/DDMF";
	}
	else if((platformLocation as any).location.host=="uat2-telco.ctos.com.my"){
		this.url= "//uat-telco.ctos.com.my/DDMF";
	}

	
	}

	dateToDB(d: string) {
		let x = new Date(d);
		if (!x || !d) return '';
		return x.getFullYear()+ '-' + this._pZ(x.getMonth() + 1)+ '-' + this._pZ(x.getDate());
	}

	_pZ(v: number) {
		return v < 10 ? '0'+v : v;
	}

	_checkSession(options?: any) {
		//console.log(this);
		//console.log(this.router.url);
		//if (this.snackRef) this.snackRef.dismiss();
		let user = sessionStorage.getItem('logged_in_user');
		if (user!=null && user !== '') {
			// console.log(options, 'options');
			let jsonData = JSON.parse(user);
			let curT = new Date().getTime();
			let loggedTime = jsonData.timeStamp || 0;
			let sessionEndTime = loggedTime + (this.SESSION_TTL * 60 * 1000);
			if (sessionEndTime > curT) {
				let redirectFlag = true;
				jsonData.timeStamp = curT;
				sessionStorage.setItem('logged_in_user', JSON.stringify(jsonData));
				if (options) {
					let currentUrl = options.page;
					//if (options.page === 'login') {
							for (var i in jsonData['listGroupMenus']) {
								//console.log(jsonData['listGroupMenus'][i]['router'],currentUrl.replace('/', ''));
								if (jsonData['listGroupMenus'][i]['router'] === currentUrl.replace('/', '')) {
									redirectFlag = false;
									break;
								}
							}
							//DDMF-101 Start
							//Enforce the first-time login user to change their password
							if(jsonData.firstTimeLoginInd=='Y'){
								redirectFlag = false;
								this.router.navigateByUrl('/change-password');
							}
							//DDMF-101 End
							if (redirectFlag) {
								if(jsonData.groupId=="100"){    	
									this.router.navigateByUrl('/manage-users');
									
								} else {
									this.router.navigateByUrl(jsonData['listGroupMenus'][0]['router']);
									
								}
							}					
						
					//}
				}
				return jsonData;
			}
			sessionStorage.setItem('logged_in_user', '');
		}
		this.router.navigateByUrl('/');
		// console.log(user, 'user');
	}

	validateEmail (email: string){

	    let EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	    return EMAIL_REGEXP.test(email) ? true : false;
	}
	
	//DDMF-101: Start
	validatePassword (password: string){
		let PASSWORD_REGEXP = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&`~^<>,.;:'"\[\]\{\}\(\)|\/\-_\\=+])[A-Za-z\d$@$!%*#?&`~^<>,.;:'"\[\]\{\}\(\)|\/\-_\\=+]{8,}$/;
		return PASSWORD_REGEXP.test(password) ? true : false;
	}
	//DDMF-101: End
	
	notify (message: string, type?: string, dismiss?: boolean) {
		if (!message) message = 'Something went wrong!! Please try again later.';
		if ((/login again/).test(message)) {
			//Special Case Handled For Multiple Session
			this.commonMsg = message; 
			sessionStorage.setItem('logged_in_user', '');
			this.router.navigateByUrl('/');
		}
		let duration = dismiss ? 5000 : 0;
		this.snackRef = this.matSnackBar.open(message, 'Close', {
			duration: duration,
			extraClasses: ['ctos-snackbar']
		});
		//console.log(this.snackRef);
	}

	exportCSV (items: any[], filename?: string, header?: any[]) {
		let replacer = (key, value) => value === null ? '' : value
		if (!header) header = Object.keys(items[0])
		let rawHead = header.map(head => head.toUpperCase())
		// rawHead.map(head => head.toUpperCase())
		let csv = items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
		csv.unshift(rawHead.join(','))
		let final_csv = csv.join('\r\n')
		// console.log(final_csv, 'csvvvvvvvvvvvvvvvvvv');

		let blob = new Blob([final_csv], {type: 'application/csv'});
		if (!filename) filename = new Date().getTime() + '.csv';
		FileSaver.saveAs(blob, filename);
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/utils-service.ts